<app-header>
  <app-breadcrumbs [breadcrumbs]="breadcrumbs"></app-breadcrumbs>
</app-header>
<mat-toolbar class="main-toolbar cf-flex-row cf-justify-content-end" color="primary">
  <div class="left-side">
    <span class="title">{{ 'UI.ProjectPrices.HoodPrices' | translate }}</span>
  </div>
  <button
    mat-button
    (click)="exportProjectToPyramid()"
    [disabled]="disablePyramid(feedbackMessages$ | async, projectEntity$ | async) || !hasExportSelected(projectEntity$ | async)"
    [matTooltip]="'UI.ProjectPrices.ExportToPyramid.Tooltip' | translate"
  >
    {{ 'UI.ProjectPrices.ExportToPyramid' | translate }}
  </button>
  <button
    mat-button
    (click)="getReportProjectPrices()"
    [matTooltip]="'UI.ProjectPrices.ExportToExcel.Tooltip' | translate"
    [disabled]="!hasExportSelected(projectEntity$ | async)"
  >
    {{ 'UI.ProjectPrices.ExportToExcel' | translate }}
  </button>
  <app-project-file-download></app-project-file-download>
</mat-toolbar>
<div class="main-content">
  <div *ngIf="showLoading$ | async" class="loading cf-flex-row cf-justify-content-center">
    <mat-progress-spinner mode="indeterminate" color="primary"></mat-progress-spinner>
  </div>

  <div *ngIf="(showLoading$ | async) === false" class="cf-flex-column cf-gap-24">
    <div *ngIf="projectEntity$ | async as projectEntity">
      <app-project-prices [projectEntity]="projectEntity"></app-project-prices>
    </div>
  </div>
</div>
